import { cn } from "@/lib/utils";
import Image from "next/image";

import { Text } from "./Text";

export const Empty = ({
    imgurl,
    mainText,
    subText,
    className,
    ...props
}: {
    className?: string;
    imgurl: string;
    mainText: string | React.ReactNode;
    subText?: string | React.ReactNode;
}) => {
    return (
        <div
            className={cn(
                "flex flex-col items-center pt-[17vh] md:pt-[13vh]",
                className
            )}
            {...props}
        >
            <div className="relative mb-9 h-[140px] w-[140px] md:mb-6 md:h-20 md:w-20">
                <Image alt="empty" src={imgurl} fill />
            </div>
            {typeof mainText === "string" ? (
                <Text
                    className="!important md:text-h4 mb-3 break-keep text-center font-medium md:mb-2"
                    variant="h3"
                >
                    {mainText}
                </Text>
            ) : (
                mainText
            )}
            {subText &&
                (typeof subText === "string" ? (
                    <Text
                        className="md:text-body3 whitespace-pre-wrap text-center"
                        variant="body1"
                        color="text.disabled"
                    >
                        {subText}
                    </Text>
                ) : (
                    subText
                ))}
        </div>
    );
};
